export default function fieldValidator(field) {
  let anyFieldError = false;

  const isRequired = field.rules && field.rules.includes('required');
  const isEmail = field.rules && field.rules.includes('email');
  const value = field.value || null;

  if (isRequired && !value) {
    anyFieldError = true;
  } else if (isEmail && value) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const validateEmail = re.test(String(value).toLowerCase());

    if (!validateEmail) {
      anyFieldError = true;
    }
  }

  field.error = anyFieldError;

  return !anyFieldError;
}
